// extracted by mini-css-extract-plugin
export default {"container":"Weather_container__WPQgC","deg":"Weather_deg__elw6a","icon":"Weather_icon__WsymR","rotate":"Weather_rotate__Zq2jp"};